import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiAction } from "../../../api/ApiAction";
import { endpoints } from "../../../api/endpoints";
import { IDestinationCountry } from "../../../api/types/directory/IDestinationCountry";
import { DirectoryTarget } from "../../directory/thunks/directoryTarget";
import { RootState } from "../../rootState";

interface Params {
  operator?: number | string;
  departureCity?: number | string;
  target?: DirectoryTarget;
}

export const fetchServiceDestinationCountries = createAsyncThunk<
  IDestinationCountry[],
  Params,
  { state: RootState }
>("services/getCountries", async (param, thunkAPI) => {
  const result = await endpoints.directory.get(
    {
      action: ApiAction.getDestinationCountries,
      operator: param.operator,
      departure: param.departureCity,
    },
    thunkAPI.signal,
  );

  return result as IDestinationCountry[];
});
